import React from 'react';
import { FormLabel, Grid, TextField } from '@mui/material';

/** A labelled value an edit drawer shows but can't change, in its Grid; sm: its width from the sm breakpoint up (default 6). */
export const AdminReadOnlyField = ({ label, value, sm }) => (
	<Grid size={{ xs: 12, sm: sm ?? 6 }}>
		<FormLabel>{label}</FormLabel>
		<TextField fullWidth value={value} slotProps={{ input: { readOnly: true } }} />
	</Grid>
);
